import React from 'react'
import { useInView } from 'react-intersection-observer';
import './experience.css'
import {BsFillPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  const { ref: expRef, inView: myElementIsVisible } = useInView();

  let titleStyle = myElementIsVisible ? 'fade-in' : 'fade-out'

  let fe = 'experience__frontend '
  fe += myElementIsVisible ? 'show-from-left' : 'hide-from-left'
  let be = 'experience__backend '
  be += myElementIsVisible ? 'show-from-right' : 'hide-from-right'
  let ts = 'experience__tools '
  ts += myElementIsVisible ? 'show-from-left' : 'hide-from-left'
  let fw = 'experience__framework '
  fw += myElementIsVisible ? 'show-from-right' : 'hide-from-right'
  return (
    <section id='experience' ref={expRef}>
      <h5 className={titleStyle}>What Skill I Have</h5>
      <h2 className={titleStyle}>My Experience</h2>

      <div className="container experience__container">
        <div className={fe}>
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>HTML</h4>
                <small className='text-light'>+6 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>CSS</h4>
                <small className='text-light'>+6 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Bootstrap</h4>
                <small className='text-light'>+5 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>+6 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Tailwind</h4>
                <small className='text-light'>4 Months</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>TypeScript</h4>
                <small className='text-light'>1 Month</small>
              </div>
            </article>
          </div>
        </div>

        <div className={be}>
        <h3>Backend Development</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>PHP</h4>
                <small className='text-light'>+5 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>C#</h4>
                <small className='text-light'>+2 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Java</h4>
                <small className='text-light'>+1 Year</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>ASP.NET Web Core API</h4>
                <small className='text-light'>6 Months</small>
              </div>
            </article>
          </div>
        </div>

        <div className={ts}>
        <h3>Tools</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Visual Studio Code</h4>
                <small className='text-light'>+4 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Git Bash</h4>
                <small className='text-light'>+1 Year</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>MySQL</h4>
                <small className='text-light'>+4 Years</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Figma</h4>
                <small className='text-light'>+1 Year</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>XAMPP</h4>
                <small className='text-light'>+6 Years</small>
              </div>
            </article>
          </div>
        </div>

        <div className={fw}>
        <h3>Framework</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Laravel</h4>
                <small className='text-light'>3 Months</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>ReactJS</h4>
                <small className='text-light'>5 Months</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Vue 3</h4>
                <small className='text-light'>6 Months</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>NextTS</h4>
                <small className='text-light'>1 Month</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>ReactTS</h4>
                <small className='text-light'>1 Month</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience